import { render, staticRenderFns } from "./BinSummary.vue?vue&type=template&id=ec8312ae&scoped=true"
import script from "./BinSummary.vue?vue&type=script&lang=js"
export * from "./BinSummary.vue?vue&type=script&lang=js"
import style0 from "./BinSummary.vue?vue&type=style&index=0&id=ec8312ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8312ae",
  null
  
)

export default component.exports